import { gql } from '../../../apollo/__generated__';

export const STAFF_LEAVE_BEDROOM = gql(`
  mutation StaffLeaveBedroom($bedroomId: ID!, $eventId: ID!, $userId: ID!) {
    staffLeaveBedroom(bedroomId: $bedroomId, eventId: $eventId, userId: $userId) {
      id
      floor
      doorNumber
      maxUsers
      users(eventId: $eventId) {
        id
        firstname
        lastname
        nickname
        studyTown
      }
    }
  }
`);
